"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _themeUi = require("theme-ui");

var _Icon = _interopRequireDefault(require("../Icon/Icon"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var ChevronIcon = function ChevronIcon(props) {
  return (0, _themeUi.jsx)("svg", props, (0, _themeUi.jsx)("path", {
    d: "M207.029 381.476L12.686 187.132c-9.373-9.373-9.373-24.569 0-33.941l22.667-22.667c9.357-9.357 24.522-9.375 33.901-.04L224 284.505l154.745-154.021c9.379-9.335 24.544-9.317 33.901.04l22.667 22.667c9.373 9.373 9.373 24.569 0 33.941L240.971 381.476c-9.373 9.372-24.569 9.372-33.942 0z"
  }));
};

ChevronIcon.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 448 512"
};

var AccordionHeader = function AccordionHeader(_ref) {
  var id = _ref.id,
      contentId = _ref.contentId,
      expanded = _ref.expanded,
      onClick = _ref.onClick,
      children = _ref.children,
      iconPosition = _ref.iconPosition,
      props = _objectWithoutPropertiesLoose(_ref, ["id", "contentId", "expanded", "onClick", "children", "iconPosition"]);

  return (0, _themeUi.jsx)("button", _extends({}, props, {
    id: id,
    sx: {
      display: 'flex',
      justifyContent: iconPosition === 'left' ? 'flex-start' : 'space-between',
      alignItems: 'center',
      width: '100%',
      p: 2,
      borderTopStyle: 'solid',
      borderTopWidth: 'thin',
      borderTopColor: 'neutral.1'
    },
    "aria-expanded": expanded
  }, contentId && {
    'aria-controls': contentId
  }, {
    onClick: onClick
  }), children && iconPosition === 'right' && children, (0, _themeUi.jsx)(_Icon["default"], {
    icon: ChevronIcon,
    sx: {
      color: 'inherit',
      transform: expanded ? 'rotate(-180deg)' : 'rotate(0deg)',
      transitionTimingFunction: function transitionTimingFunction(theme) {
        return theme.easing.standard;
      },
      transition: 'transform 200ms',
      mr: iconPosition === 'left' ? 2 : 0
    }
  }), children && iconPosition === 'left' && children);
};

AccordionHeader.propTypes = {
  id: _propTypes["default"].string,
  contentId: _propTypes["default"].string,
  expanded: _propTypes["default"].bool,
  onClick: _propTypes["default"].func,
  children: _propTypes["default"].node,
  iconPosition: _propTypes["default"].oneOf(['left', 'right'])
};
AccordionHeader.defaultProps = {
  id: null,
  contentId: null,
  expanded: false,
  onClick: null,
  children: null,
  iconPosition: 'right'
};
var _default = AccordionHeader;
exports["default"] = _default;